module.exports = __webpack_public_path__ + "static/media/monoful-brand-white.b26735bd.svg";